module.exports = __webpack_public_path__ + "static/img/6.b4bd74c6.jpg";